import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  onMutationStartedDefault,
  onQueryStartedDefault,
} from "./serviceUtility";

export const adminApi = createApi({
  reducerPath: "adminApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_Base_Url}`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("token", token);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (data) => ({
        url: `/admin/api/login`,
        method: "POST",
        body: data,
      }),
      onQueryStarted: onMutationStartedDefault,
    }),
    logout: builder.mutation({
      query: (postData) => {
        return {
          url: `/user-api/auth/logout`,
          method: "POST",
          body: { ...postData },
        };
      },
      onQueryStarted: onMutationStartedDefault,
    }),
    getLogs: builder.query({
      query: (data) => ({
        url: `/admin/api/get-logs`,
        method: "GET",
        params: { ...data },
      }),
      onQueryStarted: onQueryStartedDefault,
    }),
    getLogsData: builder.query({
      query: (data) => ({
        url: `/admin/api/get-details`,
        method: "GET",
        params: { ...data },
      }),
      onQueryStarted: onQueryStartedDefault,
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useLazyGetLogsQuery,
  useGetLogsDataQuery,
} = adminApi;
